import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3148LogicalUnit } from "../../../../U3148Service";
import type { U3148RoleActionHandler } from "./U3148RoleActionHandlers";

// Typage des props du composant
interface U3148RoleActionDeleteDlgProps {
  u3148RoleActionHandler: U3148RoleActionHandler;
  t: TFunction;
  NS: string;
}

// Composant pour la boîte de dialogue de suppression d'une action de rôle
function U3148RoleActionDeleteDlg({ u3148RoleActionHandler, t, NS }: U3148RoleActionDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u3148RoleActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u3148RoleActionHandler.isDeleteDialogOpen} onClose={u3148RoleActionHandler.onDlgDeleteClose} title={t("role.lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("role.msgDeleteRole", {
          count: u3148RoleActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3148RoleActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U3148LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3148RoleActionDeleteDlg;
